// extracted by mini-css-extract-plugin
export default {"header":"header_header__Ly3O2","logo":"header_logo__rIIFj"};